module.exports = __webpack_public_path__ + "static/img/blueberry-pomegranate-m.68af5bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/blueberry-pomegranate-m.jpg
// module id = /YYb
// module chunks = 0